
export default {
  props: {
    headerColor: {
      type: String,
      required: false,
      default: null
    },
    isMobilePreviewOpen: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.loadingCount > 0
    },
  },
  methods: {
    hasTopHeader () {
      return !!this.$slots['top-header']
    },
    hasSidebar () {
      return !!this.$slots.sidebar
    },
  }
}
